<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        header="Assign vehicle models to sample"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '800px' }"
        (onHide)="this.close()"
>
    <div class="my-2">
        <p-floatlabel variant="on">
            <p-iconfield>
                <p-inputicon class="pi pi-search"/>
                <input pInputText id="on_label" [(ngModel)]="this.search" autocomplete="off"
                       (input)="this.onSearch($event)">
            </p-iconfield>
            <label for="on_label">Search vehicle model</label>
        </p-floatlabel>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 rounded-sm p-2">
        <p-table
                [value]="this.vehicleModels"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [loading]="this.loading"
                [first]="this.page * this.rows"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.loadVehicleModels($event)"
                [paginator]="true"
                [selection]="this.selectedVehicleModels"
                (selectionChange)="this.onSelectionChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Vehicle Model Name</th>
                    <th>Model Series</th>
                    <th>Brand</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-vehicleModel>
                <tr [pSelectableRow]="vehicleModel">
                    <td>
                        <p-tableCheckbox [value]="vehicleModel"></p-tableCheckbox>
                    </td>
                    <td>{{ vehicleModel.label }}</td>
                    <td>{{ vehicleModel.modelSeries }}</td>
                    <td>{{ vehicleModel.brand?.label }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="mt-5 py-5 flex justify-end">
        <p-button label="Assign" icon="pi pi-plus" (click)="this.addVehicleModels()"
                  [disabled]="!this.selectedVehicleModels.length"></p-button>
    </div>
</p-dialog>
